module.exports = __webpack_public_path__ + "static/media/mobile-form.f5542d0e.svg";